"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Warning;
(function (Warning) {
    /** Straight rows of keys are easy to guess */
    Warning["SpatialStraightRow"] = "SpatialStraightRow";
    /** Short keyboard patterns are easy to guess */
    Warning["SpatialShortKeyboardPattern"] = "SpatialShortKeyboardPattern";
    /** Repeats like "aaa" are easy to guess */
    Warning["RepeatCharacter"] = "RepeatCharacter";
    /** Repeats like "abcabcabc" are only slightly harder to guess than "abc" */
    Warning["RepeatPattern"] = "RepeatPattern";
    /** Sequences like abc or 6543 are easy to guess */
    Warning["Sequence"] = "Sequence";
    /** Recent years are easy to guess */
    Warning["RegexYear"] = "RegexYear";
    /** Dates are often easy to guess */
    Warning["Date"] = "Date";
    /** This is a common password */
    Warning["CommonPassword"] = "CommonPassword";
    /** This is similar to a commonly used password */
    Warning["SimilarToCommonPassword"] = "SimilarToCommonPassword";
    /** This has name */
    Warning["Name"] = "Name";
})(Warning = exports.Warning || (exports.Warning = {}));
//# sourceMappingURL=types.js.map